import { Text } from "@zapier/design-system";
import styles from "./RelatedTemplates.module.css";
import { TemplateCard } from "src/components/TemplateCard";
import { ZapCardTemplate } from "src/components/ZapCard";

interface RelatedTemplatesProps {
  relatedTemplates: ZapCardTemplate[];
}

export const RelatedTemplates = ({
  relatedTemplates,
}: RelatedTemplatesProps) => {
  if (relatedTemplates.length === 0) {
    return null;
  }

  return (
    <section>
      <div className={styles.sectionTitle}>
        <Text tag="h2" type="PageHeader">
          Related Templates
        </Text>
      </div>
      <ul className={styles.templates}>
        {relatedTemplates.map((template) => (
          <li key={template.slug}>
            <TemplateCard template={template} />
          </li>
        ))}
      </ul>
    </section>
  );
};
